var map = {
	"./cascatavideo.mp4": 8721,
	"./govideo.mp4": 108,
	"./homevideo.mp4": 7116,
	"./pedravideo.mp4": 6567,
	"./penedavideo.mp4": 5059,
	"./soajovideo.mp4": 1869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 287;